var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    { staticStyle: { position: "relative", display: "inline-block" } },
    [
      _c("i", {
        staticClass: "el-icon-arrow-down el-icon-delete",
        staticStyle: {
          position: "absolute",
          top: "6px",
          right: "24px",
          color: "#878d9f",
          cursor: "pointer",
          "z-index": "1",
        },
        on: { click: _vm.removeItem },
      }),
      _c(
        "el-dropdown",
        {
          attrs: { trigger: "click", size: "mini" },
          on: { command: _vm.clickItem },
        },
        [
          _c(
            "span",
            { staticClass: "el-dropdown-link" },
            [
              _c(
                "el-tag",
                {
                  staticClass: "item-axis",
                  attrs: { size: "small", type: _vm.tagType },
                },
                [
                  _c(
                    "span",
                    { staticStyle: { float: "left" } },
                    [
                      _vm.item.deType === 0
                        ? _c("svg-icon", {
                            staticClass: "field-icon-text",
                            attrs: { "icon-class": "field_text" },
                          })
                        : _vm._e(),
                      _vm.item.deType === 1
                        ? _c("svg-icon", {
                            staticClass: "field-icon-time",
                            attrs: { "icon-class": "field_time" },
                          })
                        : _vm._e(),
                      _vm.item.deType === 2 || _vm.item.deType === 3
                        ? _c("svg-icon", {
                            staticClass: "field-icon-value",
                            attrs: { "icon-class": "field_value" },
                          })
                        : _vm._e(),
                      _vm.item.deType === 5
                        ? _c("svg-icon", {
                            staticClass: "field-icon-location",
                            attrs: { "icon-class": "field_location" },
                          })
                        : _vm._e(),
                      _vm.chart.type === "chart-mix" &&
                      _vm.item.chartType === "bar"
                        ? _c("svg-icon", {
                            attrs: {
                              "icon-class": "bar",
                              "class-name": "field-icon-sort",
                            },
                          })
                        : _vm._e(),
                      _vm.chart.type === "chart-mix" &&
                      _vm.item.chartType === "line"
                        ? _c("svg-icon", {
                            attrs: {
                              "icon-class": "line",
                              "class-name": "field-icon-sort",
                            },
                          })
                        : _vm._e(),
                      _vm.chart.type === "chart-mix" &&
                      _vm.item.chartType === "scatter"
                        ? _c("svg-icon", {
                            attrs: {
                              "icon-class": "scatter",
                              "class-name": "field-icon-sort",
                            },
                          })
                        : _vm._e(),
                      _vm.item.sort === "asc"
                        ? _c("svg-icon", {
                            attrs: {
                              "icon-class": "sort-asc",
                              "class-name": "field-icon-sort",
                            },
                          })
                        : _vm._e(),
                      _vm.item.sort === "desc"
                        ? _c("svg-icon", {
                            attrs: {
                              "icon-class": "sort-desc",
                              "class-name": "field-icon-sort",
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c(
                    "span",
                    {
                      staticClass: "item-span-style",
                      attrs: { title: _vm.item.name },
                    },
                    [_vm._v(_vm._s(_vm.item.name))]
                  ),
                  _vm.tagType === "danger" ? _c("field-error-tips") : _vm._e(),
                  _vm.chart.type !== "table-info" &&
                  _vm.item.summary &&
                  !_vm.item.chartId
                    ? _c("span", { staticClass: "summary-span" }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.$t("chart." + _vm.item.summary))
                        ),
                        false &&
                        _vm.item.compareCalc &&
                        _vm.item.compareCalc.type &&
                        _vm.item.compareCalc.type !== "" &&
                        _vm.item.compareCalc.type !== "none"
                          ? _c("span", [
                              _vm._v(
                                "-" +
                                  _vm._s(
                                    _vm.$t("chart." + _vm.item.compareCalc.type)
                                  )
                              ),
                            ])
                          : _vm._e(),
                      ])
                    : _vm._e(),
                  _c("i", {
                    staticClass: "el-icon-arrow-down el-icon--right",
                    staticStyle: {
                      position: "absolute",
                      top: "6px",
                      right: "10px",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-dropdown-menu",
                { attrs: { slot: "dropdown" }, slot: "dropdown" },
                [
                  _c(
                    "el-dropdown-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.chart.type === "chart-mix",
                          expression: "chart.type ==='chart-mix'",
                        },
                      ],
                    },
                    [
                      _c(
                        "el-dropdown",
                        {
                          staticStyle: { width: "100%" },
                          attrs: { placement: "right-start", size: "mini" },
                          on: { command: _vm.switchChartType },
                        },
                        [
                          _c(
                            "span",
                            {
                              staticClass:
                                "el-dropdown-link inner-dropdown-menu",
                            },
                            [
                              _c("span", [
                                _c("i", { staticClass: "el-icon-s-data" }),
                                _c("span", [
                                  _vm._v(_vm._s(_vm.$t("chart.chart_type"))),
                                ]),
                              ]),
                              _c("i", {
                                staticClass:
                                  "el-icon-arrow-right el-icon--right",
                              }),
                            ]
                          ),
                          _c(
                            "el-dropdown-menu",
                            { attrs: { slot: "dropdown" }, slot: "dropdown" },
                            [
                              _c(
                                "el-dropdown-item",
                                { attrs: { command: _vm.beforeSwitch("bar") } },
                                [_vm._v(_vm._s(_vm.$t("chart.chart_bar")))]
                              ),
                              _c(
                                "el-dropdown-item",
                                {
                                  attrs: { command: _vm.beforeSwitch("line") },
                                },
                                [_vm._v(_vm._s(_vm.$t("chart.chart_line")))]
                              ),
                              _c(
                                "el-dropdown-item",
                                {
                                  attrs: {
                                    command: _vm.beforeSwitch("scatter"),
                                  },
                                },
                                [_vm._v(_vm._s(_vm.$t("chart.chart_scatter")))]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-dropdown-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            !_vm.item.chartId &&
                            _vm.chart.type !== "table-info",
                          expression:
                            "!item.chartId && chart.type !== 'table-info'",
                        },
                      ],
                      attrs: { divided: _vm.chart.type === "chart-mix" },
                    },
                    [
                      _c(
                        "el-dropdown",
                        {
                          staticStyle: { width: "100%" },
                          attrs: { placement: "right-start", size: "mini" },
                          on: { command: _vm.summary },
                        },
                        [
                          _c(
                            "span",
                            {
                              staticClass:
                                "el-dropdown-link inner-dropdown-menu",
                            },
                            [
                              _c("span", [
                                _c("i", { staticClass: "el-icon-notebook-2" }),
                                _c("span", [
                                  _vm._v(_vm._s(_vm.$t("chart.summary"))),
                                ]),
                                _c(
                                  "span",
                                  { staticClass: "summary-span-item" },
                                  [
                                    _vm._v(
                                      "(" +
                                        _vm._s(
                                          _vm.$t("chart." + _vm.item.summary)
                                        ) +
                                        ")"
                                    ),
                                  ]
                                ),
                              ]),
                              _c("i", {
                                staticClass:
                                  "el-icon-arrow-right el-icon--right",
                              }),
                            ]
                          ),
                          _c(
                            "el-dropdown-menu",
                            { attrs: { slot: "dropdown" }, slot: "dropdown" },
                            [
                              _vm.item.id !== "count" &&
                              _vm.item.deType !== 0 &&
                              _vm.item.deType !== 1 &&
                              _vm.item.deType !== 5
                                ? _c(
                                    "el-dropdown-item",
                                    {
                                      attrs: {
                                        command: _vm.beforeSummary("sum"),
                                      },
                                    },
                                    [_vm._v(_vm._s(_vm.$t("chart.sum")))]
                                  )
                                : _vm._e(),
                              _vm.item.id !== "count" &&
                              _vm.item.deType !== 0 &&
                              _vm.item.deType !== 1 &&
                              _vm.item.deType !== 5
                                ? _c(
                                    "el-dropdown-item",
                                    {
                                      attrs: {
                                        command: _vm.beforeSummary("avg"),
                                      },
                                    },
                                    [_vm._v(_vm._s(_vm.$t("chart.avg")))]
                                  )
                                : _vm._e(),
                              _vm.item.id !== "count" &&
                              _vm.item.deType !== 0 &&
                              _vm.item.deType !== 1 &&
                              _vm.item.deType !== 5
                                ? _c(
                                    "el-dropdown-item",
                                    {
                                      attrs: {
                                        command: _vm.beforeSummary("max"),
                                      },
                                    },
                                    [_vm._v(_vm._s(_vm.$t("chart.max")))]
                                  )
                                : _vm._e(),
                              _vm.item.id !== "count" &&
                              _vm.item.deType !== 0 &&
                              _vm.item.deType !== 1 &&
                              _vm.item.deType !== 5
                                ? _c(
                                    "el-dropdown-item",
                                    {
                                      attrs: {
                                        command: _vm.beforeSummary("min"),
                                      },
                                    },
                                    [_vm._v(_vm._s(_vm.$t("chart.min")))]
                                  )
                                : _vm._e(),
                              _vm.item.id !== "count" &&
                              _vm.item.deType !== 0 &&
                              _vm.item.deType !== 1 &&
                              _vm.item.deType !== 5
                                ? _c(
                                    "el-dropdown-item",
                                    {
                                      attrs: {
                                        command:
                                          _vm.beforeSummary("stddev_pop"),
                                      },
                                    },
                                    [_vm._v(_vm._s(_vm.$t("chart.stddev_pop")))]
                                  )
                                : _vm._e(),
                              _vm.item.id !== "count" &&
                              _vm.item.deType !== 0 &&
                              _vm.item.deType !== 1 &&
                              _vm.item.deType !== 5
                                ? _c(
                                    "el-dropdown-item",
                                    {
                                      attrs: {
                                        command: _vm.beforeSummary("var_pop"),
                                      },
                                    },
                                    [_vm._v(_vm._s(_vm.$t("chart.var_pop")))]
                                  )
                                : _vm._e(),
                              _c(
                                "el-dropdown-item",
                                {
                                  attrs: {
                                    command: _vm.beforeSummary("count"),
                                  },
                                },
                                [_vm._v(_vm._s(_vm.$t("chart.count")))]
                              ),
                              _vm.item.id !== "count"
                                ? _c(
                                    "el-dropdown-item",
                                    {
                                      attrs: {
                                        command:
                                          _vm.beforeSummary("count_distinct"),
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("chart.count_distinct"))
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-dropdown-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            !_vm.item.chartId &&
                            _vm.chart.type !== "table-info",
                          expression:
                            "!item.chartId && chart.type !== 'table-info'",
                        },
                      ],
                    },
                    [
                      _c(
                        "el-dropdown",
                        {
                          staticStyle: { width: "100%" },
                          attrs: { placement: "right-start", size: "mini" },
                          on: { command: _vm.quickCalc },
                        },
                        [
                          _c(
                            "span",
                            {
                              staticClass:
                                "el-dropdown-link inner-dropdown-menu",
                            },
                            [
                              _c("span", [
                                _c("i", { staticClass: "el-icon-s-grid" }),
                                _c("span", [
                                  _vm._v(_vm._s(_vm.$t("chart.quick_calc"))),
                                ]),
                                _c(
                                  "span",
                                  { staticClass: "summary-span-item" },
                                  [
                                    _vm._v(
                                      "(" +
                                        _vm._s(
                                          !_vm.item.compareCalc
                                            ? _vm.$t("chart.none")
                                            : _vm.$t(
                                                "chart." +
                                                  _vm.item.compareCalc.type
                                              )
                                        ) +
                                        ")"
                                    ),
                                  ]
                                ),
                              ]),
                              _c("i", {
                                staticClass:
                                  "el-icon-arrow-right el-icon--right",
                              }),
                            ]
                          ),
                          _c(
                            "el-dropdown-menu",
                            { attrs: { slot: "dropdown" }, slot: "dropdown" },
                            [
                              _c(
                                "el-dropdown-item",
                                {
                                  attrs: {
                                    command: _vm.beforeQuickCalc("none"),
                                  },
                                },
                                [_vm._v(_vm._s(_vm.$t("chart.none")))]
                              ),
                              _c(
                                "el-dropdown-item",
                                {
                                  attrs: {
                                    disabled: _vm.disableEditCompare,
                                    command: _vm.beforeQuickCalc("setting"),
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("chart.yoy_label")) + "..."
                                  ),
                                ]
                              ),
                              _c(
                                "el-dropdown-item",
                                {
                                  attrs: {
                                    disabled:
                                      _vm.quotaViews.indexOf(_vm.chart.type) >
                                      -1,
                                    command: _vm.beforeQuickCalc("percent"),
                                  },
                                },
                                [_vm._v(_vm._s(_vm.$t("chart.percent")))]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-dropdown-item",
                    {
                      attrs: {
                        divided:
                          !_vm.item.chartId && _vm.chart.type !== "table-info",
                      },
                    },
                    [
                      _c(
                        "el-dropdown",
                        {
                          staticStyle: { width: "100%" },
                          attrs: { placement: "right-start", size: "mini" },
                          on: { command: _vm.sort },
                        },
                        [
                          _c(
                            "span",
                            {
                              staticClass:
                                "el-dropdown-link inner-dropdown-menu",
                            },
                            [
                              _c("span", [
                                _c("i", { staticClass: "el-icon-sort" }),
                                _c("span", [
                                  _vm._v(_vm._s(_vm.$t("chart.sort"))),
                                ]),
                                _c(
                                  "span",
                                  { staticClass: "summary-span-item" },
                                  [
                                    _vm._v(
                                      "(" +
                                        _vm._s(
                                          _vm.$t("chart." + _vm.item.sort)
                                        ) +
                                        ")"
                                    ),
                                  ]
                                ),
                              ]),
                              _c("i", {
                                staticClass:
                                  "el-icon-arrow-right el-icon--right",
                              }),
                            ]
                          ),
                          _c(
                            "el-dropdown-menu",
                            { attrs: { slot: "dropdown" }, slot: "dropdown" },
                            [
                              _c(
                                "el-dropdown-item",
                                { attrs: { command: _vm.beforeSort("none") } },
                                [_vm._v(_vm._s(_vm.$t("chart.none")))]
                              ),
                              _c(
                                "el-dropdown-item",
                                { attrs: { command: _vm.beforeSort("asc") } },
                                [_vm._v(_vm._s(_vm.$t("chart.asc")))]
                              ),
                              _c(
                                "el-dropdown-item",
                                { attrs: { command: _vm.beforeSort("desc") } },
                                [_vm._v(_vm._s(_vm.$t("chart.desc")))]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-dropdown-item",
                    {
                      attrs: {
                        icon: "el-icon-files",
                        command: _vm.beforeClickItem("filter"),
                      },
                    },
                    [
                      _c("span", [
                        _vm._v(_vm._s(_vm.$t("chart.filter")) + "..."),
                      ]),
                    ]
                  ),
                  _vm.chart.render === "antv" &&
                  _vm.chart.type !== "gauge" &&
                  _vm.chart.type !== "liquid"
                    ? _c(
                        "el-dropdown-item",
                        {
                          attrs: {
                            icon: "el-icon-notebook-2",
                            divided: "",
                            command: _vm.beforeClickItem("formatter"),
                          },
                        },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(_vm.$t("chart.value_formatter")) + "..."
                            ),
                          ]),
                        ]
                      )
                    : _vm._e(),
                  _c(
                    "el-dropdown-item",
                    {
                      attrs: {
                        icon: "el-icon-edit-outline",
                        divided: "",
                        command: _vm.beforeClickItem("rename"),
                      },
                    },
                    [
                      _c("span", [
                        _vm._v(_vm._s(_vm.$t("chart.show_name_set"))),
                      ]),
                    ]
                  ),
                  _c(
                    "el-dropdown-item",
                    {
                      attrs: {
                        icon: "el-icon-delete",
                        divided: "",
                        command: _vm.beforeClickItem("remove"),
                      },
                    },
                    [_c("span", [_vm._v(_vm._s(_vm.$t("chart.delete")))])]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }